import { useParams } from 'react-router-dom'

// Baut Pfade, die das aktuelle :country-URL-Segment beibehalten.
// Aufruf:  const buildPath = useCountryPath()
//          buildPath('/pages/home')  ->  '/BR/pages/home'  (wenn URL /BR/... ist)
//                                        '/pages/home'     (wenn ohne Country)
export const useCountryPath = () => {
  const { country } = useParams()
  const base = process.env.PUBLIC_URL || ''
  const prefix = country ? `/${country}` : ''
  return (path) => {
    if (!path) return `${base}${prefix}` || '/'
    const normalized = path.startsWith('/') ? path : `/${path}`
    return `${base}${prefix}${normalized}`
  }
}

export default useCountryPath
